import { config } from "@/helpers";

class Session {
  private _prefix: string;
  private _accessToken: string | null = null;
  private _refreshToken: string | null = null;
  private _userUuid: string | null = null;
  private _deviceUuid: string | null = null;
  private _login: string | null = null;
  private _password: string | null = null;

  constructor(prefix?: string) {
    this._prefix = prefix || `@yoney/${config.environment}/session`;
  }

  public set accessToken(value: string | null) {
    this._accessToken = value;

    if (null !== value) {
      localStorage.setItem(`${this._prefix}/accessToken`, value);
    } else {
      localStorage.removeItem(`${this._prefix}/accessToken`);
    }
  }

  hasAccessToken = (): boolean => !!this._accessToken;

  public get accessToken(): string {
    return this._accessToken || "";
  }

  public set refreshToken(value: string | null) {
    this._refreshToken = value;

    if (null !== value) {
      localStorage.setItem(`${this._prefix}/refreshToken`, value);
    } else {
      localStorage.removeItem(`${this._prefix}/refreshToken`);
    }
  }

  hasRefreshToken = (): boolean => !!this._refreshToken;

  public get refreshToken(): string {
    return this._refreshToken || "";
  }

  public set userUuid(value: string | null) {
    this._userUuid = value;

    if (null !== value) {
      localStorage.setItem(`${this._prefix}/userUuid`, value);
    } else {
      localStorage.removeItem(`${this._prefix}/userUuid`);
    }
  }

  public hasUserUuid = (): boolean => !!this._userUuid;

  public get userUuid(): string {
    return this._userUuid || "";
  }

  public set deviceUuid(value: string | null) {
    this._deviceUuid = value;

    if (null !== value) {
      localStorage.setItem(`${this._prefix}/deviceUuid`, value);
    } else {
      localStorage.removeItem(`${this._prefix}/deviceUuid`);
    }
  }

  public hasDeviceUuid = (): boolean => !!this._deviceUuid;

  public get deviceUuid(): string {
    return this._deviceUuid || "";
  }

  public set login(value: string | null) {
    this._login = value;

    if (null !== value) {
      localStorage.setItem(`${this._prefix}/login`, value);
    } else {
      localStorage.removeItem(`${this._prefix}/login`);
    }
  }

  hasLogin = (): boolean => !!this._login;

  public get login(): string {
    return this._login || "";
  }

  public set password(value: string | null) {
    this._password = value;

    if (null !== value) {
      localStorage.setItem(`${this._prefix}/password`, value);
    } else {
      localStorage.removeItem(`${this._prefix}/password`);
    }
  }

  hasPassword = (): boolean => !!this._password;

  public get password(): string {
    return this._password || "";
  }

  public load = async (): Promise<void> => {
    const result = await Promise.all([
      localStorage.getItem(`${this._prefix}/accessToken`),
      localStorage.getItem(`${this._prefix}/refreshToken`),
      localStorage.getItem(`${this._prefix}/userUuid`),
      localStorage.getItem(`${this._prefix}/deviceUuid`),
      localStorage.getItem(`${this._prefix}/login`),
      localStorage.getItem(`${this._prefix}/password`),
    ]);

    this._accessToken = result[0];
    this._refreshToken = result[1];
    this._userUuid = result[2];
    this._deviceUuid = result[3] ?? config.deviceUuid;
    this._login = result[4];
    this._password = result[5];
  };

  public clear = async (removeLogin: boolean = false) => {
    await Promise.all([
      localStorage.removeItem(`${this._prefix}/accessToken`),
      localStorage.removeItem(`${this._prefix}/refreshToken`),
      localStorage.removeItem(`${this._prefix}/userUuid`),
      localStorage.removeItem(`${this._prefix}/deviceUuid`),
      localStorage.removeItem(`${this._prefix}/password`),
    ]);

    if (removeLogin) {
      localStorage.removeItem(`${this._prefix}/login`);
    }
  };
}

export const session = new Session();
